import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function ChangeAuthMethods () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'Change Authentication Methods', href: '/login-help/change-auth-methods' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Change Authentication Methods</h2>

      <Card>
        <CardBody>
          <p>
            If you already have MFA set up, log in to <a href='https://schumacher.okta.com'>schumacher.okta.com</a> to add/remove MFA options.
            Once you are logged in, click your name in the upper righthand corner, then click <b>Settings</b> in the dropdown menu.
          </p>
          <img className='mb-4' src='/static/img/okta-settings-dropdown.png' alt='okta settings' />
          <p>
            On the Settings page, scroll to the <b>Extra Verification</b> section.
            From here, you can add or configure a new authentication method by clicking <b>Setup</b>.
            You can also remove an existing authentication method by clicking <b>Reset</b>.
          </p>
          <img className='mb-4' src='/static/img/okta-extra-verification.png' alt='okta extra verification' />
        </CardBody>
      </Card>
    </>
  )
}

ChangeAuthMethods.publicAccess = true

ChangeAuthMethods.getInitialProps = () => ({
  title: 'Change Authentication Methods'
})

export default ChangeAuthMethods
